import { Helmet } from "react-helmet-async";

const SITE = "https://www.xsellsolutions.in";
const DEFAULT_OG = `${SITE}/og-image.png`;

export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
}) => {
  const url = `${SITE}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large" />

      <meta property="og:site_name" content="XSell Solutions" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
